import { TohumUiModule } from '@anadolu-commons/tohum-ui';
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'aof-nav-item',
  standalone: true,
  imports: [TohumUiModule],
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss']
})
export class NavItemComponent implements OnInit {
  
  @Input() iconClass: string;
  @Output() click = new EventEmitter();

  @HostBinding('class')
  readonly className = 'thm-nav-item';

  constructor() { }

  ngOnInit(): void {
  }

  onClick() {
    this.click.emit();
  }

}

